(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yds-family-mega-menu"] && !Shopify.designMode) return;
  try {
    const initializeYdsFamilyMenus = (scope = document) => {
    scope.querySelectorAll('[data-yds-family-menu]').forEach((menu) => {
      if (menu.dataset.ydsInitialized === 'true') return;
      menu.dataset.ydsInitialized = 'true';

      const tabs = [...menu.querySelectorAll('[data-yds-family-tab]')];
      const panels = [...menu.querySelectorAll('[data-yds-family-panel]')];
      const details = menu.closest('details');
      const summary = details?.querySelector(':scope > summary');

      const activate = (tab) => {
        const targetId = tab.getAttribute('aria-controls');
        const activePanel = panels.find((panel) => panel.id === targetId);
        tabs.forEach((item) => {
          const active = item === tab;
          item.closest('[data-yds-family-tab-row]')?.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach((panel) => {
          panel.hidden = panel.id !== targetId;
        });
        const isSparse = activePanel?.classList.contains('yds-family-panel--sparse') || false;
        const footerVisibility = activePanel?.dataset.ydsFooterVisibility || 'auto';
        const hideFooter = footerVisibility === 'hide' || (footerVisibility === 'auto' && isSparse);
        menu.classList.toggle('is-sparse-active', isSparse);
        menu.classList.toggle('is-footer-hidden', hideFooter);
      };

      tabs.forEach((tab, index) => {
        const row = tab.closest('[data-yds-family-tab-row]');
        const rowLink = row?.querySelector('.yds-family-mega-menu__tab-link');
        row?.addEventListener('mouseenter', () => activate(tab));
        rowLink?.addEventListener('focus', () => activate(tab));
        tab.addEventListener('focus', () => activate(tab));
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === null) return;
          event.preventDefault();
          activate(tabs[nextIndex]);
          tabs[nextIndex].focus();
        });
      });

      const selectedTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      if (selectedTab) activate(selectedTab);

      summary?.addEventListener('focus', () => {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        details?.removeAttribute('open');
        summary?.setAttribute('aria-expanded', 'false');
        summary?.focus();
      });
    });
  };

  initializeYdsFamilyMenus();
  document.addEventListener('DOMContentLoaded', () => initializeYdsFamilyMenus());
  document.addEventListener('shopify:section:load', (event) => initializeYdsFamilyMenus(event.target));
  } catch(e) { console.error(e); }
})();

})();
